import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import companies from 'modules/core/store/collections/companies'
import type Company from 'modules/core/store/models/Company'

import atsCompanies from 'modules/ats/store/collections/atsCompanies'
import subscriptionAddons from 'modules/billing/store/collections/subscriptionAddons'
import { useDomainsList } from 'modules/company_page/hooks/useDomainsList'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { CompanyPage } from './CompanyPage'
import { Customize } from './Customize'
import { PrivacyPolicy } from './PrivacyPolicy'

const CompanyPageSettings = () => {
  const { loading } = useAsyncData(async () => {
    await subscriptionAddons.fetch()
    await atsCompanies.fetch()
  }, [])

  const company: Company = companies.current
  const { loading: loadingDomains, domains } = useDomainsList()

  return (
    <ResponsivePage.Body
      variant="narrow"
      loading={loading || loadingDomains}
      error={null}
      showHeader={false}
    >
      <CompanyPage company={company} domains={domains} />
      <Customize atsCompany={atsCompanies.current} />
      <PrivacyPolicy company={company} />
    </ResponsivePage.Body>
  )
}

export default CompanyPageSettings
